import {createRoot} from "react-dom/client";

const usePopupWindow = (component: React.ReactNode, index: number, title: string) => {
    const popup = window.open("", `_blank`, `width=600,height=600,left=${100 * index},top=${100 * index}`);

    if (!popup) return;

    popup.document.title = title;
    const div = popup.document.createElement("div");
    popup.document.body.appendChild(div);

    const root = createRoot(div);
    root.render(<>{component}</>);

    return popup;
};

export {usePopupWindow};
